{
  "languages": {
    "en": "English",
    "pt-BR": "Português (Brasil)"
  },
  "multiSelect": {
    "selectedCount": "Selecionados ({{total}})"
  },
  "nav": {
    "selectDemoOrganization": "Selecionar Organização Demo",
    "pleaseSelect": "Por favor, selecione",
    "switchOrgError": "Não foi possível trocar de organização. Tente novamente.",
    "logout": "Sair",
    "adminView": "Visão Admin",
    "producerView": "Visão Produtor",
    "switchToAdminView": "Mudar para Visão Admin",
    "switchToProducerView": "Mudar para Visão Produtor",
    "toggleDarkMode": "Alternar modo escuro"
  },
  "sectionNames": {
    "Administration": "Administração",
    "MEQ Live Admin": "MEQ Live Admin",
    "GMP Lamb Data Analysis": "Análise de Dados GMP Cordeiro",
    "GMP Lamb Bookings": "Reservas GMP Cordeiro",
    "GMP Upload": "Upload GMP",
    "Data Analysis Overview": "Visão Geral de Análise de Dados",
    "MEQ Live": "MEQ Live",
    "MEQ Probe": "MEQ Probe",
    "MEQ Camera": "MEQ Camera",
    "MEQ Live Genetics": "MEQ Live Genetics",
    "USDA Audit": "Auditoria USDA",
    "USDA Audit Feedback": "Feedback de Auditoria USDA",
    "Management": "Gerenciamento",
    "Record Labelling Admin": "Rotulagem de Registros",
    "Record Labelling": "Minhas Atribuições",
    "USDA Image Calibration": "Calibracao de Imagem USDA"
  },
  "timePeriods": {
    "twelveMonths": "12 meses",
    "threeMonths": "3 meses",
    "thirtyDays": "30 dias",
    "sevenDays": "7 dias",
    "selectDate": "Selecionar data",
    "selectRange": "Período",
    "customRange": "Período personalizado"
  },
  "footer": {
    "copyright": "Direitos Autorais © MEQ {{year}}",
    "termsAndConditions": "Termos e Condições",
    "privacyPolicy": "Política de Privacidade"
  },
  "pageTitles": {
    "administration": "Administração",
    "meqLiveAdmin": "MEQ Live Admin",
    "gmpLambDataAnalysis": "Análise de Dados GMP Cordeiro",
    "gmpLambBooking": "Reservas GMP Cordeiro",
    "gmpUpload": "GMP Upload",
    "meqDataAnalytics": "Análise de Dados MEQ",
    "meqLive": "MEQ Live",
    "meqProbe": "MEQ Probe",
    "meqCamera": "MEQ Camera",
    "meqLiveGenetics": "MEQ Live Genetics",
    "usdaAudit": "Auditoria USDA",
    "usdaAuditFeedback": "Feedback de Auditoria USDA",
    "recordLabelling": "Rotulagem de Registros",
    "myAssignments": "Minhas Atribuicoes",
    "usdaImageCalibration": "Calibracao de Imagem USDA",
    "management": "Gerenciamento",
    "working": "Trabalhando ...",
    "noPackages": "Sem Pacotes",
    "notFound": "Não Encontrado",
    "loading": "Carregando",
    "login": "Entrar",
    "authCallback": "Callback de Autenticação",
    "logout": "Sair"
  },
  "table": {
    "noRecordsToDisplay": "Não há registros a serem exibidos",
    "exportAllDataToCsv": "Exportar Todos os Dados para CSV",
    "search": "Pesquisar",
    "clearSearch": "Limpar pesquisa",
    "selectAllRows": "Selecionar todas as linhas",
    "selectRow": "Selecionar linha",
    "collapseRow": "Recolher linha",
    "expandRow": "Expandir linha",
    "showHideColumns": "Mostrar/Ocultar colunas",
    "showHideAllColumns": "Mostrar/Ocultar tudo",
    "toggleDensity": "Alternar densidade",
    "toggleFullscreen": "Alternar tela cheia",
    "filterMin": "Min",
    "filterMax": "Max",
    "rowsPerPage": "Linhas por página"
  },
  "columnNames": {
    "AA_MARBLING": "Marmoreio AA",
    "AGE": "Idade",
    "AGREEMENT_RATE_PCT": "Taxa de Concordância %",
    "ANIMAL_PRODUCT_CODE": "Código do Produto Animal",
    "ANIMAL_PRODUCT_NAME": "Nome do Produto Animal",
    "AUS_MARBLING": "Marmoreio AUS",
    "AVG_AUS_MARBLING": "Média Marmoreio AUS",
    "AVG_EYE_MUSCLE_AREA": "Média Área do Músculo do Olho",
    "AVG_FAT_COLOR": "Média Cor da Gordura",
    "AVG_HUMP_HEIGHT": "Média Altura da Corcova",
    "AVG_IMF": "Média IMF",
    "AVG_IMF_PERCENTAGE_OF": "Média IMF %",
    "AVG_JBS_WAGYU_MARBLING": "Média Marmoreio JBS Wagyu",
    "AVG_MSA_MARBLING": "Média Marmoreio MSA",
    "AVG_RIB_EYE_AREA": "Média Área do Contrafilé",
    "AVG_RIB_FAT": "Média Gordura da Costela",
    "AVG_SUBCUTANEOUS_FAT": "Média Gordura Subcutânea",
    "AVG_USDA_MARBLING": "Média Marmoreio USDA",
    "AVG_YG": "Média YG",
    "BARCODE": "Código de Barras",
    "BMS_MARBLING": "Marmoreio BMS",
    "BODY_NO": "Nº do Corpo",
    "BODY_NUMBER": "Número do Corpo",
    "CARCASE_HOTWEIGHT": "Peso Quente da Carcaça",
    "CARCASE_NOTE": "Observação da Carcaça",
    "CARCASE_SIDE": "Lado da Carcaça",
    "CHOICE_PCT": "% Choice",
    "CITY_NAME": "Nome da Cidade",
    "COMPANY_CODE": "Código da Empresa",
    "COUNT_AUS_MARBLING": "Total Marmoreio AUS",
    "COUNT_EYE_MUSCLE_AREA": "Total AMO",
    "COUNT_IMF": "Total IMF",
    "COUNT_JBS_WAGYU_MARBLING": "Total Marmoreio Wagyu",
    "COUNT_MSA_MARBLING": "Total MSA",
    "COUNT_RIB_EYE_AREA": "Total Área do Contrafilé",
    "EID": "EID",
    "EYE_MUSCLE_AREA": "Área do Músculo do Olho",
    "EYE_MUSCLE_AREA_UNITS": "Unidades Área do Músculo do Olho",
    "FARMER_CODE": "Código do Produtor",
    "FARMER_NAME": "Nome do Produtor",
    "FARM_CODE": "Código da Fazenda",
    "FARM_NAME": "Nome da Fazenda",
    "FAT_COLOR": "Cor da Gordura",
    "FINENESS": "Finura",
    "FL_MARBLING": "Marmoreio FL",
    "FMP_MARBLING": "Marmoreio FMP",
    "GROUPED_PRODUCT_NAME": "Nome do Produto Agrupado",
    "HCW": "HCW",
    "HUMP_HEIGHT": "Altura da Corcova",
    "IMF": "IMF %",
    "IMF_VISUAL": "IMF Visual",
    "IS_DCULITE": "É DCU Lite",
    "JBS_WAGYU_MARBLING": "Marmoreio JBS Wagyu",
    "KEYFRAME_HASH": "Hash do Keyframe",
    "KILL_DATE": "Data do Abate",
    "KPH": "KPH",
    "LMY": "LMY %",
    "LOCATION": "Local",
    "LOTBATCH": "Lote",
    "MEAT_COLOR_4_PLUS": "% Cor da Carne 4+",
    "MEAT_TYPE": "Tipo de Carne",
    "MEQ_MEAT_COLOR": "MEQ Cor da Carne",
    "MSA_MARBLING": "Marmoreio MSA",
    "NOTE": "Observação",
    "NUMBER_OF_IMAGES": "Número de Imagens",
    "OPERATOR_MEAT_COLOR": "Cor da Carne do Operador",
    "OVERRIDE_AUS_MARBLING": "Substituição Marmoreio AUS",
    "OVERRIDE_BMS_MARBLING": "Substituição Marmoreio BMS",
    "OVERRIDE_EYE_MUSCLE_AREA": "Substituição Área do Músculo do Olho",
    "OVERRIDE_FAT_COLOR": "Substituição Cor da Gordura",
    "OVERRIDE_IMF": "Substituição IMF %",
    "OVERRIDE_MSA_MARBLING": "Substituição Marmoreio MSA",
    "OVERRIDE_PCT": "% de Substituição Acima",
    "OVERRIDE_RIB_FAT": "Substituição Gordura da Costela",
    "OVERRIDE_USDA_MARBLING": "Substituição Marmoreio USDA",
    "PHOTO_DATE": "Data da Foto",
    "PHOTO_DATETIME": "Data e Hora da Foto",
    "PLANT_AUS": "Marmoreio AUS da Planta",
    "PLANT_EMA": "Área do Músculo do Olho da Planta",
    "PLANT_MSA": "Marmoreio MSA da Planta",
    "PLANT_RIBFAT": "Gordura da Costela da Planta",
    "PRIME_PCT": "% Prime",
    "PYG": "PYG",
    "RIB_EYE_AREA": "Área do Contrafilé",
    "RIB_EYE_AREA_UNITS": "Unidades Área do Contrafilé",
    "RIB_FAT": "Gordura da Costela",
    "RIB_FAT_UNITS": "Unidades Gordura da Costela",
    "SELECT_PCT": "% Select",
    "SEX": "Sexo",
    "STATE_NAME": "Nome do Estado",
    "SUBCUTANEOUS_FAT": "Gordura Subcutânea",
    "SUPPLIER": "Fornecedor",
    "UNDERRIDE_PCT": "% de Substituição Abaixo",
    "USDA_MARBLING": "Marmoreio USDA",
    "USER": "Usuário",
    "YG": "YG"
  },
  "authSplash": {
    "headline": "Inteligência objetiva de medições,",
    "headlineAccent": "em todos os turnos.",
    "tagline": "O MEQ Insights reúne medição de animais vivos, classificação por câmera, medições por sonda e desempenho da planta — para que sua equipe tome a mesma decisão que os dados.",
    "statValue": "4,2M",
    "statLabel": "Carcaças classificadas",
    "welcome": "Bem-vindo de volta",
    "subtitle": "Entre no seu espaço de trabalho MEQ Insights.",
    "logIn": "Entrar",
    "logOut": "Sair",
    "loading": "Carregando..."
  },
  "authErrors": {
    "title": "Não foi possível carregar o MEQ Insights",
    "sessionCheckFailed": "Não foi possível acessar o serviço de login. Verifique sua conexão e tente novamente.",
    "bootFailed": "Algo deu errado ao carregar sua conta. Tente novamente ou saia e entre de novo.",
    "userNotFound": "Não encontramos uma conta do MEQ Insights para este login. Saia e entre com outra conta ou fale com o administrador.",
    "noAccessibleOrgs": "Sua conta ainda não tem acesso a nenhuma organização. Fale com o administrador ou saia e entre com outra conta.",
    "retry": "Tentar novamente",
    "logOut": "Sair"
  },
  "selectOrg": {
    "prompt": "Selecione uma organização para continuar",
    "placeholder": "Selecione uma organização",
    "legacyTitle": "Obrigado",
    "legacyPrompt": "Selecione uma organização para continuar."
  },
  "outdatedClient": {
    "title": "O Insights foi atualizado",
    "message": "Esta aba está executando uma versão anterior do Insights. Atualize a página para continuar.",
    "action": "Atualizar página"
  },
  "routeError": {
    "title": "Algo deu errado",
    "message": "Não foi possível exibir esta página. Já fomos notificados. Atualize a página para tentar novamente.",
    "action": "Atualizar página"
  }
}
